import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
export const Divider = ({ style, type }) => {
    const styles = useStyleSheet(getStyles);
    return React.createElement(View, { style: [styles.container, styles[type], style] });
};
const getStyles = createStyleSheet(({ color }) => ({
    container: {
        backgroundColor: color.invert2.p4,
        alignSelf: 'stretch'
    },
    vertical: {
        width: 1
    },
    horizontal: {
        height: 1
    }
}));
//# sourceMappingURL=index.js.map